import { OnChangeFn, SortingState } from '@tanstack/react-table';
import { useCallback, useMemo, useState } from 'react';

type Direction = 'asc' | 'desc';

export function useApiSorting(
  sortKeyByColumnId: Record<string, string> = {},
  onSortChange?: () => void
) {
  const [sorting, setSorting] = useState<SortingState>([]);

  const handleSortingChange: OnChangeFn<SortingState> = useCallback(
    (updaterOrValue) => {
      setSorting((currentSorting) => {
        const nextSorting =
          typeof updaterOrValue === 'function' ? updaterOrValue(currentSorting) : updaterOrValue;
        onSortChange?.();
        return nextSorting;
      });
    },
    [onSortChange]
  );

  const sortParams = useMemo(() => {
    const activeSort = sorting[0];
    if (!activeSort) return {};

    return {
      sort: sortKeyByColumnId[activeSort.id] ?? activeSort.id,
      direction: (activeSort.desc ? 'desc' : 'asc') as Direction,
    };
  }, [sortKeyByColumnId, sorting]);

  return {
    sorting,
    setSorting,
    handleSortingChange,
    sortParams,
  };
}
